module.exports = __webpack_public_path__ + "img/Modern-cosmetics-book-Gift-Pop-up.e4e0b15e.png";